<template>
  <el-select
    v-model="selfValue"
    :remote="true"
    filterable
    reserve-keyword
    :placeholder="placeholder"
    :remote-method="search"
    :loading="loading"
    v-bind="config"
    :clearable="clearable"
    @visible-change="visibleChange"
  >
    <i v-if="!loading" slot="prefix" class="el-icon-search"> </i>
    <el-option
      v-for="item in rows"
      :key="item.id"
      :value="item.id"
      :label="(item.name ? item.name + ' - ' : '') + item.mobile"
    >
      <div class="d-flex justify-content-between">
        <span>{{ item.name }}</span>
        <small>{{ item.mobile }}</small>
      </div>
    </el-option>
  </el-select>
</template>

<script>
import UsersQuery from '@/graphql/user/UsersListMin.gql'

export default {
  name: 'UserSelect',
  props: {
    value: { type: [Number, String, Object], default: '' },
    config: { type: [Object], default: () => ({}) },
    clearable: { type: Boolean, default: false }
  },
  data() {
    return {
      loading: false,
      placeholder: '',
      selfValue: '',
      query: '',
      list: [],
      store: []
    }
  },
  computed: {
    title() {
      return ' جستجو در کاربران'
    },
    rows: {
      set(value) {
        this.list = value
      },
      get() {
        let items = {}
        this.list.forEach(item => (items[item.id] = item))
        this.store.forEach(item => (items[item.id] = item))
        return Object.values(items)
      }
    },
    row() {
      return this.rows.find(u => u.id === this.value)
    }
  },
  watch: {
    value: {
      handler(val) {
        this.selfValue = val ? String(val) : val
        if (val) {
          this.search(val, true)
        } else {
          this.list = []
          this.store = []
        }
      },
      immediate: true
    },
    selfValue(val) {
      this.$emit('input', val)
    }
  },
  created() {
    this.placeholder = this.title
  },
  methods: {
    visibleChange(e) {
      this.placeholder = e ? 'جستجو نام' : this.title
    },
    search(query, id) {
      this.query = query
      if (id && this.rows.find(u => u.id === query)) return
      if (query !== '') {
        const filter = {
          field: 'name',
          op: 'like',
          value: this.$route.params.userName
            ? this.$route.params.userName
            : query
        }
        if (query.toString().replace(/\d/g, '') === '') {
          if (/^09[0-9]{9}$/.test(query)) {
            filter.value = query.toString().replace(/^09/, '9')
            filter.field = 'mobile'
          }
        }
        let graphQuery = UsersQuery
        this.apollo
          .mutate({
            query: graphQuery,
            variables: {
              filter: { limit: 20, filters: [filter] }
            }
          })
          .then(response => {
            let items = response.data.result.items
            this[id ? 'store' : 'list'] = items
            if (this.onAdvisers && !items.length) {
              this.selfValue = ''
            } else {
              this.selfValue = this.value
            }
          })
      } else {
        this.list = []
      }
    }
  }
}
</script>
<style lang="scss">
.el-select {
  .el-input {
    input {
      padding-right: 15px;
    }
    .el-input__prefix {
      position: relative !important;
      left: 0 !important;
      .el-icon-search {
        height: 100%;
        width: 25px;
        text-align: center;
        left: 10px;
        position: absolute;
        -webkit-transition: all 0.3s;
        transition: all 0.3s;
        line-height: 40px;
      }
    }
    .el-input__suffix {
      .el-input__suffix-inner {
        .el-select__caret {
          margin-left: 20px !important;
          margin-top: -0.2px !important;
          font-size: 15px !important;
        }
      }
    }
  }
}
</style>
